/**
 * Author: ligj@mapbar.com
 * Create Time: 2017/12/15 15:15
 * Description: 拦截器配置
 */

let Interceptors = {
    request: function (config) {
        let token = window.localStorage.getItem('wedof_itsm_web_token') || null;
        if(token){
            config.headers['token'] = token;
        }
        return config;
    },
    requestError: function (error) {
        // console.log(error,'requestError');
        return Promise.reject(error);
    },
    response: function (response) {
        // console.log(response,'response');
        if(!response.data.code){
          response.data.code = response.data.status || response.data.resultCode ;
        };
        return response;
    },
    responseError: function (error) {
        // console.log(error.response.data);
        // console.log(error);
        // const {response}=error
        // console.log(response);
        // console.log(error.response);
        if (!error.response) {
            let res={}
            res.message='网络繁忙，请检查网络连接'
            return Promise.reject(res);
        }
        // console.log(error.response.status);
        if (error.response.status===401) {
            location.href='#/login'
            let res={}
            res.status=401
            res.message='请求超时，请重新登陆(cookie失效)'
            return Promise.reject(res);
        }

        // if (error.response) {
        //     switch (error.response.status) {
        //         case 401:
        //             console.log('hahaha401');
        //             console.log(aaa);
        //             // 返回 401 清除token信息并跳转到登录页面
        //             // this.$store.dispatch('logout')
        //             //     this.$router.push({
        //             //         path:'/login'
        //             //     })
        //             location.href='#/login'
        //            break
        //     }
        //     // return Promise.reject('hahaha')
        // }
        return Promise.reject(error.response);
    }
};

export default Interceptors;
